import { forwardRef, type Ref, type SVGProps } from "react";

function SvgSuitcase(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        d="M5 4.333H3.667a2 2 0 0 0-2 2v5.334a2 2 0 0 0 2 2h8.666a2 2 0 0 0 2-2V6.333a2 2 0 0 0-2-2H11m-6 0v-.666a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v.666m-6 0h6m-.333 7c.826 0 1.513-.602 1.644-1.391a.55.55 0 0 0-.173-.47l-1.276-1.277a.55.55 0 0 0-.47-.172 1.667 1.667 0 0 0 .275 3.31ZM4.717 9.62l1.99-.724a.667.667 0 0 0 .398-.855l-.255-.7a.667.667 0 0 0-.854-.4l-1.99.725a.667.667 0 0 0-.4.855l.256.7a.667.667 0 0 0 .855.4Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSuitcase);
export default ForwardRef;
